<!-- =========================================================================================
    File Name: Email.vue
    Description: Email Application (Inbox)

    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->
<template>
  <vx-card>
    <StartGuideText >
       <div v-if="showRequestAcademy">
          <div>
            <vs-button icon-pack="feather" size="large" :disabled="$store.getters.isAnonymous" @click="setAcademyRequested" :class="{'cursor-not-allowed': $store.getters.isAnonymous, 'animate-bounce': $route.query.startAcademy}" type="relief">

              <span class="flex items-center">
                  <feather-icon icon="BookOpenIcon" class="mr-2"></feather-icon>
                  <span class="font-bold">show me the first session</span>
              </span>

            </vs-button>
          </div>
           <div class="flex flex-wrap justify-center font-italic hover:underline">
            <span v-if="$store.getters.isAnonymous" class="text-center cursor-pointer" @click="register">

            *you need to register first</span>
            <!-- <p v-else class="text-center">free for improvee.io users</p> -->
           </div>
        </div>
         <div v-else>
            <div>
              <div class="flex justify-center items-center text-center">
                <feather-icon icon="UserCheckIcon"></feather-icon><span class="ml-1">You are signed up</span>
              </div>
              <div class="text-center font-semibold">
                Academy starts soon
              </div>
            </div>
         </div>
    </StartGuideText>

  </vx-card>
</template>

<script>
import StartGuideText from '../Tips/StartGuideText.vue'
// import _ from 'lodash'
// import moduleEmail         from '@/store/email/moduleEmail.js'

export default {
  components: {
    StartGuideText
  },
  data () {
    return {
      showRequestAcademy: false,
    }
  },
  watch: {
    isSidebarActive (value) {
      if (!value) this.showThread = false
    },
    windowWidth () {
      this.setSidebarWidth()
    }
  },
  computed: {
    guideStarted () {
      return this.$store.getters.academyRequested
    },
  },
  methods: {
    register () {
      this.$router.push('/login').catch(() => {})
    },
    setAcademyRequested () {
      this.$store.dispatch('SET_ACADEMY_REQUESTED')
      this.showRequestAcademy = false

      if (window.smoothscroll) {
        window.smoothscroll()
      } else {
        window.scrollTo(0,0)
      }
    },
  },
  mounted () {
    this.showRequestAcademy = !this.guideStarted
  },
}

</script>
